export interface AnimeCategory {
  id: string;
  name: string;
  tagline: string;
  desc: string;
  icon: string;
  count: number;
  match: string[];
}

export interface AnimeItem {
  id: string;
  title: string;
  titleEn: string;
  year: string;
  season: string;
  genres: string[];
  episode: number;
  episodeMin: number;
  totalMin: number;
  rating: number;
  status: string;
  synopsis: string;
  why: string;
  bestScene: string;
  tags: string[];
  image: string;
  accent: string;
}

export interface ArticleItem {
  id: string;
  title: string;
  excerpt: string;
  date: string;
  readMin: number;
  tag: string;
  image: string;
  content: string[];
}

export const animeCategories: AnimeCategory[] = [
  {
    id: "xiafan",
    name: "下饭番",
    tagline: "边吃边看，越看越香",
    desc: "节奏轻快、笑点密集的日常短番，最适合搭配每一顿正餐，三分钟一集刚刚好。",
    icon: "ri-bowl-line",
    count: 24,
    match: ["下饭", "边吃边看", "日常", "笑点", "三分钟"],
  },
  {
    id: "moyu",
    name: "摸鱼短番",
    tagline: "摸鱼五分钟，快乐一整天",
    desc: "适合上班上学间隙偷闲的短篇，短小精悍，看完立刻回到正题，毫无负担。",
    icon: "ri-moon-line",
    count: 18,
    match: ["摸鱼", "上班", "上学", "间隙", "短篇", "短小"],
  },
  {
    id: "gaoxiao",
    name: "搞笑短篇",
    tagline: "全程无尿点，笑到打嗝",
    desc: "沙雕脑洞、无厘头笑料，专治不开心，看的时候千万别喝水。",
    icon: "ri-emotion-laugh-line",
    count: 20,
    match: ["搞笑", "沙雕", "脑洞", "无厘头", "笑料", "无尿点"],
  },
  {
    id: "zhiyu",
    name: "治愈系",
    tagline: "暖暖的，被治愈到",
    desc: "温柔细腻的日常与碎碎念，一个人在家看也觉得很安心，适合睡前放松。",
    icon: "ri-cup-line",
    count: 16,
    match: ["治愈", "温暖", "日常", "碎碎念", "睡前", "放松"],
  },
  {
    id: "sanfen",
    name: "泡面三分钟",
    tagline: "一集三分钟，泡面刚刚好",
    desc: "专为泡面而生的短番，从拆盖到开动，正好一集看完，时间管理大师最爱。",
    icon: "ri-timer-line",
    count: 26,
    match: ["泡面", "三分钟", "短番", "时间管理", "拆盖", "开动"],
  },
  {
    id: "yikouqi",
    name: "一口气看完",
    tagline: "总长不超两小时",
    desc: "总时长很短的番剧合集，一个周末下午就能补完，追更零压力。",
    icon: "ri-speed-line",
    count: 22,
    match: ["一口气", "看完", "短时长", "周末", "补完", "零压力"],
  },
];

export const animeList: AnimeItem[] = [
  {
    id: "fangxue-moyu",
    title: "放学后的摸鱼时光",
    titleEn: "After-School Slacking Time",
    year: "2024",
    season: "春季番",
    genres: ["日常", "搞笑", "校园"],
    episode: 12,
    episodeMin: 4,
    totalMin: 48,
    rating: 9.2,
    status: "已完结",
    synopsis:
      "放学铃声一响，值日班长小满就拉着好友冲进天台，开启每天最快乐的摸鱼三分钟。从吐槽作业到比拼零食，四个死党把放学后的每一分钟都过得有声有色，笑点密到喘不过气。",
    why: "节奏快到飞起，每集一个独立小剧场，完全不用担心追不上剧情，笑点密集又接地气，是一口气刷完也不会腻的那种。",
    bestScene: "午休、课间、以及一切想偷偷放松的时刻",
    tags: ["校园", "下饭", "爆笑", "一口气"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20four%20high%20school%20students%20relaxing%20on%20a%20sunny%20rooftop%20terrace%20after%20school%2C%20eating%20snacks%20and%20laughing%2C%20warm%20golden%20afternoon%20light%2C%20cozy%20soft%20pastel%20palette%2C%20minimal%20clean%20style%2C%20anime%20poster%20composition&width=600&height=800&seq=anime-fangxue-01&orientation=portrait",
    accent: "primary",
  },
  {
    id: "sanfen-chufang",
    title: "三分钟厨房奇谭",
    titleEn: "Three-Minute Kitchen Tales",
    year: "2023",
    season: "秋季番",
    genres: ["美食", "日常", "治愈"],
    episode: 10,
    episodeMin: 3,
    totalMin: 30,
    rating: 8.8,
    status: "已完结",
    synopsis:
      "一碗泡面引发的脑洞冒险：面饼下锅的三分钟里，锅里的面条小人过上了浓缩的一生。从打工面试到买房娶妻，三分钟看完一锅面的跌宕人生，又好笑又暖心。",
    why: "把平凡的三分钟拍出花来，脑洞奇大，配合泡面一起吃效果翻倍，治愈与搞笑并存的短篇佳作。",
    bestScene: "泡面下锅的每一刻，就是它的主战场",
    tags: ["美食", "脑洞", "治愈", "泡面"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20a%20steaming%20bowl%20of%20instant%20noodles%20with%20tiny%20noodle%20characters%20living%20a%20busy%20life%20inside%2C%20warm%20cozy%20kitchen%20background%2C%20soft%20pastel%20warm%20tones%2C%20whimsical%20and%20fun%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-chufang-02&orientation=portrait",
    accent: "secondary",
  },
  {
    id: "moyu-bu",
    title: "摸鱼部的日常",
    titleEn: "Slacking Club Daily",
    year: "2024",
    season: "夏季番",
    genres: ["日常", "沙雕", "职场"],
    episode: 13,
    episodeMin: 5,
    totalMin: 65,
    rating: 9.0,
    status: "连载中",
    synopsis:
      "社畜阿泽加入了一个神奇的兴趣部——摸鱼部，部长宣称『摸鱼是对生活的尊重』。从此上班族的午休时间变成了开不完的茶话会、睡不醒的觉和理直气壮的偷懒哲学。",
    why: "社畜代入感拉满，句句都说在我心上，摸鱼哲学既好笑又解压，摸鱼时刻看它最有共鸣。",
    bestScene: "午休、工作间隙、地铁通勤",
    tags: ["职场", "摸鱼", "沙雕", "解压"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20an%20office%20worker%20sneaking%20a%20nap%20and%20drinking%20tea%20during%20lunch%20break%20at%20a%20cozy%20office%2C%20warm%20soft%20colors%2C%20playful%20and%20relaxed%20mood%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-moyubu-03&orientation=portrait",
    accent: "accent",
  },
  {
    id: "paomian-shi",
    title: "泡面时间到了",
    titleEn: "Noodle Time Now",
    year: "2022",
    season: "冬季番",
    genres: ["美食", "日常", "轻松"],
    episode: 12,
    episodeMin: 3,
    totalMin: 36,
    rating: 8.6,
    status: "已完结",
    synopsis:
      "每当深夜饿了，主人公就会端出一碗泡面，然后镜头一转，进入热气腾腾的料理幻想。每一集解锁一种泡面新吃法，从加蛋到加芝士，看着看着就饿了。",
    why: "深夜放毒神器，三分钟看完全程流口水，堪称泡面伴侣天花板，搭配夜宵食用更佳。",
    bestScene: "深夜、加班后、一个人的宵夜时间",
    tags: ["美食", "泡面", "轻松", "深夜"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20instant%20noodle%20with%20an%20egg%20and%20cheese%20in%20a%20bowl%20at%20night%20with%20warm%20lamp%20glow%2C%20cozy%20night%20scene%2C%20steam%20rising%2C%20soft%20warm%20palette%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-paomian-04&orientation=portrait",
    accent: "primary",
  },
  {
    id: "maomi-coffee",
    title: "猫咪咖啡屋",
    titleEn: "Cat Café Days",
    year: "2023",
    season: "春季番",
    genres: ["治愈", "日常", "动物"],
    episode: 11,
    episodeMin: 4,
    totalMin: 44,
    rating: 9.1,
    status: "已完结",
    synopsis:
      "城市角落有一间只开三分钟的小咖啡屋，店里的猫咪店员会用猫语接待每一位疲惫的客人。泡一杯热牛奶、撸一把毛，三分钟的治愈时光把一天的疲惫都揉碎了。",
    why: "没有剧情压力，只有暖暖的猫和软软的光，治愈力满分，睡前看一集整个人都松下来。",
    bestScene: "睡前、心情低落、想要被治愈的时候",
    tags: ["猫咪", "治愈", "睡前", "轻松"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20several%20cats%20as%20baristas%20serving%20milk%20in%20a%20cozy%20tiny%20coffee%20shop%2C%20warm%20soft%20lighting%2C%20pastel%20warm%20tones%2C%20gentle%20soothing%20mood%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-coffee-05&orientation=portrait",
    accent: "accent",
  },
  {
    id: "wuxiu-juchang",
    title: "打工人的午休剧场",
    titleEn: "Lunch Break Theater",
    year: "2024",
    season: "春季番",
    genres: ["职场", "搞笑", "日常"],
    episode: 14,
    episodeMin: 4,
    totalMin: 56,
    rating: 8.7,
    status: "连载中",
    synopsis:
      "工位变成小剧场，午休的十二点整准时开演。从甲方改稿到老板画饼，每一幕都是打工人心照不宣的日常，笑着笑着就懂了。",
    why: "职场痛点全踩中，笑点与辛酸齐飞，和同事一起看能笑到打鸣，午休摸鱼首选。",
    bestScene: "午休、加班间隙、和同事一起",
    tags: ["职场", "午休", "搞笑", "共鸣"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20office%20workers%20putting%20on%20a%20mini%20theater%20play%20around%20their%20desks%20during%20lunch%20break%2C%20playful%20workplace%20scene%2C%20warm%20bright%20colors%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-wuxiu-06&orientation=portrait",
    accent: "secondary",
  },
  {
    id: "shechu-xiaoquewei",
    title: "社畜的小确幸",
    titleEn: "Salaryman's Little Joys",
    year: "2023",
    season: "秋季番",
    genres: ["日常", "治愈", "职场"],
    episode: 12,
    episodeMin: 3,
    totalMin: 36,
    rating: 8.9,
    status: "已完结",
    synopsis:
      "加班到深夜的社畜，总能在回家路上发现微小而确实的幸福：便利店加热过的饭团、末班车靠窗的空位、家里还亮着的那盏灯。三分钟的温柔，献给每一个努力生活的你。",
    why: "把平凡日子里的光一点点收集起来，看完心里暖烘烘的，是给打工人的温柔情书。",
    bestScene: "下班路上、深夜、情绪需要充电时",
    tags: ["治愈", "职场", "暖心", "睡前"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20a%20tired%20salaryman%20finding%20small%20joy%20of%20a%20warm%20rice%20ball%20and%20city%20lights%20on%20his%20way%20home%20at%20night%2C%20warm%20glowing%20cityscape%2C%20gentle%20cozy%20mood%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-shechu-07&orientation=portrait",
    accent: "primary",
  },
  {
    id: "zhouno-daosaochu",
    title: "周末大扫除大会",
    titleEn: "Weekend Clean-Up Rally",
    year: "2022",
    season: "夏季番",
    genres: ["日常", "搞笑", "家庭"],
    episode: 10,
    episodeMin: 4,
    totalMin: 40,
    rating: 8.4,
    status: "已完结",
    synopsis:
      "每到周末，家里就会爆发一场『大扫除大会』。拖把大战、抹布对决、和沙发底下的陈年旧物斗智斗勇，一家人的周末从鸡飞狗跳到温馨收场，笑中带暖。",
    why: "家庭日常笑料百出，扫除也能扫出欢乐，周末宅家看它简直绝配。",
    bestScene: "周末宅家、做家务时",
    tags: ["家庭", "搞笑", "周末", "日常"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20a%20family%20having%20a%20chaotic%20fun%20cleaning%20day%20with%20mops%20and%20dusters%20at%20home%2C%20warm%20bright%20cozy%20interior%2C%20playful%20messy%20energy%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-daosaochu-08&orientation=portrait",
    accent: "accent",
  },
  {
    id: "zhuanjiao-tianpin",
    title: "转角甜品屋",
    titleEn: "Corner Sweets Shop",
    year: "2024",
    season: "夏季番",
    genres: ["美食", "治愈", "日常"],
    episode: 13,
    episodeMin: 4,
    totalMin: 52,
    rating: 9.0,
    status: "连载中",
    synopsis:
      "小巷转角有间只营业三分钟的甜品屋，店长每天只做一份当日限定。慕斯、布丁、焦糖蛋糕轮番登场，每一集都在治愈选择困难症的你。",
    why: "画面甜到发光，看完想立刻冲去甜品店，治愈系甜点番，心情不好时的最佳解药。",
    bestScene: "下午茶、周末午后、甜品脑袋必看",
    tags: ["甜品", "治愈", "美食", "下午茶"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20a%20tiny%20sweets%20shop%20with%20gorgeous%20desserts%20like%20mousse%20and%20pudding%20in%20a%20warm%20cozy%20laneway%2C%20soft%20pastel%20warm%20tones%2C%20sweet%20gentle%20mood%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-tianpin-09&orientation=portrait",
    accent: "secondary",
  },
  {
    id: "kejian-shifen",
    title: "课间十分钟",
    titleEn: "Ten-Minute Recess",
    year: "2023",
    season: "春季番",
    genres: ["校园", "搞笑", "青春"],
    episode: 12,
    episodeMin: 4,
    totalMin: 48,
    rating: 8.5,
    status: "已完结",
    synopsis:
      "课间十分钟能发生什么？借橡皮、传纸条、排队抢食堂、在走廊偶遇心动的人。一集一个课间，把青春里细碎的快乐都定格下来。",
    why: "满满的校园青春回忆杀，轻松好笑又带点小悸动，一口气看完仿佛回到学生时代。",
    bestScene: "课间、通勤路上、怀念青春时",
    tags: ["校园", "青春", "搞笑", "回忆"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20middle%20school%20students%20enjoying%20a%20lively%20ten-minute%20recess%20in%20a%20sunny%20school%20corridor%2C%20playful%20youthful%20energy%2C%20warm%20bright%20colors%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-kejian-10&orientation=portrait",
    accent: "primary",
  },
  {
    id: "shenye-shitang",
    title: "深夜食堂·番外篇",
    titleEn: "Midnight Diner Side Stories",
    year: "2024",
    season: "冬季番",
    genres: ["美食", "治愈", "深夜"],
    episode: 11,
    episodeMin: 5,
    totalMin: 55,
    rating: 9.3,
    status: "已完结",
    synopsis:
      "深夜十二点的路边小摊，只卖三分钟一份的简单料理，却装满了每个夜归人的心事。一碗热汤下肚，再难熬的夜晚也有了下一次出发的力气。",
    why: "深夜的治愈食堂，一边吃宵夜一边看，人生百味都在这三分钟里，温暖到想哭。",
    bestScene: "深夜、失眠、一人食时刻",
    tags: ["深夜", "治愈", "美食", "暖心"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20a%20quiet%20midnight%20street%20food%20stall%20serving%20a%20warm%20soup%20bowl%20to%20a%20lone%20customer%2C%20soft%20warm%20night%20glow%2C%20cozy%20melancholic%20mood%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-shitang-11&orientation=portrait",
    accent: "accent",
  },
  {
    id: "shaonian-danqu",
    title: "少年与单曲循环",
    titleEn: "Boy on Repeat",
    year: "2022",
    season: "春季番",
    genres: ["青春", "音乐", "治愈"],
    episode: 12,
    episodeMin: 3,
    totalMin: 36,
    rating: 8.8,
    status: "已完结",
    synopsis:
      "耳机里单曲循环的少年，把同一首歌听出了不同的心情。三分钟一集，一集一首歌的时间，用音乐串起一段温柔又有点遗憾的青春。",
    why: "每一集都有配乐小彩蛋，画面和音乐完美咬合，看完会忍不住找出自己的单曲循环，青春治愈力满格。",
    bestScene: "戴上耳机、通勤、想安静的时候",
    tags: ["音乐", "青春", "治愈", "文艺"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20a%20young%20boy%20wearing%20headphones%20listening%20to%20music%20under%20soft%20warm%20light%2C%20musical%20notes%20floating%2C%20gentle%20nostalgic%20mood%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-danqu-12&orientation=portrait",
    accent: "secondary",
  },
  {
    id: "yuanshen-zhai",
    title: "元气少女宅日常",
    titleEn: "Cheerful Otaku Days",
    year: "2023",
    season: "夏季番",
    genres: ["日常", "搞笑", "宅向"],
    episode: 13,
    episodeMin: 4,
    totalMin: 52,
    rating: 8.6,
    status: "已完结",
    synopsis:
      "元气满满的宅系少女，把独居生活过成了快乐源泉。追番、买谷、做饭、收拾房间，一个人的小日子也能过得闪闪发光。",
    why: "宅宅日常真实又有代入感，元气值拉满，看完心情瞬间变好，独居青年狠狠共鸣。",
    bestScene: "宅家周末、追番时刻、独居日常",
    tags: ["宅向", "日常", "搞笑", "独居"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20a%20cheerful%20otaku%20girl%20enjoying%20a%20cozy%20single-life%20day%20with%20figures%20and%20anime%20posters%20at%20home%2C%20warm%20bright%20colors%2C%20lively%20playful%20mood%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-yuanshen-13&orientation=portrait",
    accent: "primary",
  },
  {
    id: "tianqi-kanfan",
    title: "天气好的话去看番",
    titleEn: "Watch on a Nice Day",
    year: "2024",
    season: "秋季番",
    genres: ["治愈", "日常", "文艺"],
    episode: 10,
    episodeMin: 5,
    totalMin: 50,
    rating: 8.7,
    status: "连载中",
    synopsis:
      "天气好的午后，最适合窝在窗边看一集暖暖的短番。这部番就像一扇透光的窗，把阳光、微风和好心情都请进房间里。",
    why: "画面和名字一样治愈，适合挑个天气好的日子慢慢看，看完连心情都跟着放晴。",
    bestScene: "晴天午后、窗边、晒太阳时",
    tags: ["治愈", "文艺", "阳光", "放松"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20a%20person%20cozily%20watching%20anime%20by%20a%20sunlit%20window%20on%20a%20clear%20nice%20day%2C%20warm%20golden%20sunlight%2C%20soft%20pastel%20palette%2C%20peaceful%20relaxed%20mood%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-tianqi-14&orientation=portrait",
    accent: "accent",
  },
  {
    id: "yangtai-bohe",
    title: "阳台上的薄荷",
    titleEn: "Mint on the Balcony",
    year: "2023",
    season: "冬季番",
    genres: ["治愈", "生活", "日常"],
    episode: 12,
    episodeMin: 3,
    totalMin: 36,
    rating: 8.9,
    status: "已完结",
    synopsis:
      "租下老房子的女孩，在阳台种下一盆薄荷。从浇花到发呆，从煮薄荷茶到和邻居闲聊，三分钟的琐碎日常里，藏着认真生活的温柔。",
    why: "平平淡淡才是真，画面清清爽爽像薄荷一样舒服，看完想立刻去种一盆植物，治愈又治愈。",
    bestScene: "晨间、阳台、想要慢下来的时候",
    tags: ["治愈", "生活", "轻松", "独居"],
    image: "https://readdy.ai/api/search-image?query=cute%20flat%20illustration%20of%20a%20girl%20tending%20a%20potted%20mint%20plant%20and%20drinking%20mint%20tea%20on%20a%20sunny%20balcony%2C%20fresh%20cool%20green%20and%20warm%20tones%2C%20serene%20peaceful%20mood%2C%20minimal%20anime%20style%2C%20poster%20composition&width=600&height=800&seq=anime-bohe-15&orientation=portrait",
    accent: "secondary",
  },
];

export const hotArticles: ArticleItem[] = [
  {
    id: "ruhe-kuaichong",
    title: "如何用两小时一口气刷完一整季泡面番",
    excerpt: "整理出一套『短篇速刷不迷路』的追番技巧，从选番到排期，让你的下饭时间高效又有趣。",
    date: "2026-08-10",
    readMin: 6,
    tag: "追番指南",
    image: "https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20person%20speed-watching%20short%20anime%20episodes%20on%20a%20laptop%20with%20a%20stack%20of%20episodes%20and%20a%20clock%2C%20warm%20cozy%20colors%2C%20playful%20minimal%20style&width=1200&height=700&seq=article-kuaichong-01&orientation=landscape",
    content: [
      "追番最怕追到一半断更，或者一季太长追不完。对于泡面番来说，两小时刷完一整季其实完全可行。关键在于选番和排期。",
      "选番时优先选择每集时长在 3 到 5 分钟之间的短篇，避免单集过长拖慢进度。排期上建议按主题或风格分组，比如把搞笑番集中看，或者把治愈番放在睡前。",
      "另外，利用碎片时间也很重要。通勤路上、午休间隙，都可以用来刷一集。这样既能保持追番节奏，又不会占用太多整块时间。"
    ]
  },
  {
    id: "xiafan-peitao",
    title: "下饭番的黄金搭配：这些短番配饭最香",
    excerpt: "摸鱼部、泡面时间、周末大扫除……盘点适合边吃边看的下饭番，让每一顿饭都不孤单。",
    date: "2026-08-02",
    readMin: 5,
    tag: "下饭推荐",
    image: "https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20cozy%20dining%20table%20with%20meals%20and%20a%20tablet%20playing%20short%20anime%2C%20warm%20appetizing%20colors%2C%20playful%20minimal%20style&width=1200&height=700&seq=article-xiafan-02&orientation=landscape",
    content: [
      "下饭番的核心在于节奏轻快、笑点密集，适合搭配正餐食用。摸鱼部、泡面时间、周末大扫除这类番剧，都是边吃边看的绝佳选择。",
      "摸鱼部适合在午休或工作间隙观看，节奏轻松，笑点密集，能迅速缓解工作压力。泡面时间则更适合深夜或加班后食用，三分钟一集，刚好配合泡面食用。",
      "周末大扫除适合在周末宅家时观看，家庭日常笑料百出，扫除也能扫出欢乐，是周末宅家看番的绝佳选择。"
    ]
  },
  {
    id: "moyu-shouce",
    title: "上班摸鱼看番生存手册",
    excerpt: "怎么在老板眼皮底下优雅摸鱼看番？这份通勤与午休的摸鱼指南，请收好（也请别被发现）。",
    date: "2026-07-25",
    readMin: 4,
    tag: "摸鱼指南",
    image: "https://readdy.ai/api/search-image?query=flat%20illustration%20of%20an%20office%20worker%20secretly%20watching%20short%20anime%20on%20phone%20under%20the%20desk%20during%20work%2C%20playful%20sneaky%20mood%2C%20warm%20bright%20colors%2C%20minimal%20style&width=1200&height=700&seq=article-moyu-03&orientation=landscape",
    content: [
      "摸鱼看番的核心在于隐蔽性和节奏感。通勤路上可以利用碎片时间刷一集，午休时则可以选择节奏轻快的短篇。",
      "选择番剧时优先选择每集时长在 3 到 5 分钟之间的短篇，避免单集过长拖慢进度。排期上建议按主题或风格分组，比如把搞笑番集中看，或者把治愈番放在睡前。",
      "另外，利用碎片时间也很重要。通勤路上、午休间隙，都可以用来刷一集。这样既能保持追番节奏，又不会占用太多整块时间。"
    ]
  },
];